import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CityService } from 'app/shared/services/cidades.service';
import { PermissionService } from 'app/shared/services/permissoes.service';
import { BreadcrumbService } from 'app/shared/services/breadcrumb.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import Api from 'app/helpers/api';
import App from 'app/helpers/app';
import Me from 'app/helpers/me';
import { HttpClient } from '@angular/common/http';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-detalhe-minicipio',
  templateUrl: './detalhe-minicipio.component.html',
  styleUrls: ['./detalhe-minicipio.component.scss']
})
export class DetalheMinicipioComponent implements OnInit {

  municipio: any = {};
  permissoes: any[] = [];
  idCidade: number = 0;
  carregando: boolean = true;

  // Dados para edição na modal
  dadosEdicao: any = {
    cep: '',
    estado: '',
    municipio: '',
    logradouro: '',
    numero: '',
    complemento: '',
    bairro: ''
  };

  // Listas para dropdowns
  estados: any[] = [
    { nome: 'Rio Grande do Sul', sigla: 'RS' },
    { nome: 'São Paulo', sigla: 'SP' },
    { nome: 'Rio de Janeiro', sigla: 'RJ' },
    { nome: 'Minas Gerais', sigla: 'MG' },
    // Adicionar outros estados conforme necessário
  ];

  municipios: any[] = [];

  // Propriedades para Integração FlaxFlow
  anexo = {
    arquivos: [],
    opcao: "processarEAnexar"
  };
  statusEnvio: string = '';
  cidadeUsuarios = {
    city: '',
    users: []
  };
  apiCall: any;

  // Lista de módulos/funcionalidades disponíveis
  modulos = [
    {
      titulo: 'Parametrização e Configurações',
      descricao: 'Gerencie o cadastro do município, incluindo órgãos e outras informações.',
      icone: 'fa-cog',
      rota: '/page/municipio/orgaos'
    },
    {
      titulo: 'Usuários e Acessos',
      descricao: 'Consulte e gerencie os usuários do sistema responsáveis pela operação do município.',
      icone: 'fa-users',
      rota: '/page/usuarios'
    },
    {
      titulo: 'Central de Importações',
      descricao: 'Importe diretamente dados para o município e realize operações em lote.',
      icone: 'fa-upload',
      rota: '/page/importacoes'
    },
    {
      titulo: 'Relatórios',
      descricao: 'Gere e exporte dados do município que estão atualmente na base de dados.',
      icone: 'fa-file-text-o',
      rota: '/page/municipio/relatorios'
    },
    {
      titulo: 'Servidores Cadastrados',
      descricao: 'Consulte os servidores cadastrados no município e suas informações.',
      icone: 'fa-user',
      rota: '/page/servidores'
    },
    {
      titulo: 'Acesso Remoto',
      descricao: 'Consulte e gerencie os servidores com acesso direto ao seu cadastro no sistema.',
      icone: 'fa-wifi',
      rota: '/page/municipio/usuarios'
    },
    {
      titulo: 'Permissões e Acesso',
      descricao: 'Permissões do município cadastrado no sistema.',
      icone: 'fa-key',
      rota: '/page/permissoes'
    },
    {
      titulo: 'Integração FlaxFlow',
      descricao: 'Envie e processe documentos através da integração FlaxFlow.',
      icone: 'fa-link',
      rota: 'flaxflow',
      isModal: true
    }
  ];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private cityService: CityService,
    private permissionService: PermissionService,
    private cdr: ChangeDetectorRef,
    private breadcrumbService: BreadcrumbService,
    private modalService: NgbModal,
    private spinner: NgxSpinnerService,
    private api: Api,
    private app: App,
    private me: Me,
    private http: HttpClient
  ) {
    this.apiCall = this.api.new().silent();
  }

  async ngOnInit(): Promise<void> {
    // Configurar breadcrumbs imediatamente para detalhe município (apenas 2 níveis)
    this.breadcrumbService.setDetalheMunicipioBreadcrumbs();
    
    this.route.queryParams.subscribe(async parametros => {
      console.log('Parâmetros recebidos:', parametros);
      if (parametros['idCidade']) {
        this.idCidade = Number(parametros['idCidade']);
        console.log('ID da cidade:', this.idCidade);
        if (this.idCidade && this.idCidade > 0) {
          await this.loadData();
        } else {
          console.error('ID da cidade inválido:', this.idCidade);
          this.carregando = false;
          this.cdr.detectChanges();
        }
      } else {
        console.error('Parâmetro idCidade não encontrado');
        this.carregando = false;
        this.cdr.detectChanges();
      }
    });
  }

  async loadData() {
    try {
      console.log('Iniciando carregamento dos dados para cidade:', this.idCidade);
      this.carregando = true;
      this.cdr.detectChanges();
      
      // Carrega dados do município e permissões em paralelo
      const [municipioData, permissoesData] = await Promise.all([
        this.cityService.getCidadeById({id: this.idCidade}),
        this.permissionService.getPermissoes()
      ]);

      console.log('Dados recebidos - Município:', municipioData);
      console.log('Dados recebidos - Permissões:', permissoesData);

      this.municipio = municipioData;
      this.permissoes = permissoesData || [];
      this.carregando = false;
      
      console.log("Municipio: ", this.municipio);
      console.log("Permissões: ", this.permissoes);
      
      // Força a detecção de mudanças
      this.cdr.detectChanges();
    } catch (error) {
      console.error('Erro ao carregar dados:', error);
      this.carregando = false;
      this.cdr.detectChanges();
    }
  }

  // Método para obter todas as badges que devem ser exibidas
  getBadges(): any[] {
    const badges = [];
    
    // Adiciona o badge de Pendência no Cadastro apenas se há pendências
    if (this.hasPendenciasCadastro()) {
      badges.push({
        nome: 'Pendência no Cadastro',
        tipo: 'pendencia'
      });
    }
    
    // Adiciona badges baseadas nas permissões do sistema
    if (this.permissoes && this.permissoes.length > 0) {
      this.permissoes.forEach(permissao => {
        badges.push({
          nome: permissao.nome,
          tipo: 'permissao',
          id: permissao.id
        });
      });
    }
    
    return badges;
  }

  // Método para navegar para uma rota específica
  navigateToModule(modulo: any) {
    // Tratamento especial para Acesso Remoto - passa nomeCidade como parâmetro
    if (modulo.titulo === 'Acesso Remoto') {
      const nomeCidade = this.municipio?.municipio?.nome;
      if (nomeCidade) {
        this.router.navigate([modulo.rota], { queryParams: { nomeCidade: nomeCidade } });
      } else {
        console.warn('Nome da cidade não encontrado para Acesso Remoto');
        this.router.navigate([modulo.rota], { queryParams: { idCidade: this.idCidade } });
      }
    } else if (modulo.titulo === 'Permissões e Acesso') {
      // Tratamento especial para Permissões - passa nomeCidade como parâmetro
      const nomeCidade = this.municipio?.municipio?.nome;
      if (nomeCidade) {
        this.router.navigate(['/page/permissoes'], { queryParams: { nomeCidade: nomeCidade } });
      } else {
        console.warn('Nome da cidade não encontrado para Permissões');
        this.router.navigate(['/page/permissoes'], { queryParams: { idCidade: this.idCidade } });
      }
    }else if(modulo.titulo === 'Usuários e Acessos'){
      const nomeCidade = this.municipio?.municipio?.nome;
      this.router.navigate(['/page/usuarios'], { queryParams: { nomeCidade: nomeCidade } });
    } else {
      // Para todas as outras rotas, usa o ID da cidade
      this.router.navigate([modulo.rota], { queryParams: { idCidade: this.idCidade } });
    }
  }

  // Método específico para navegação via ícone de edição (Configurações/Órgãos)
  navigateToConfiguracao() {
    this.router.navigate(['/page/municipio/orgaos'], { queryParams: { idCidade: this.idCidade } });
  }

  // Método para verificar se há pendências no cadastro básico
  hasPendenciasCadastro(): boolean {
    if (!this.municipio || !this.municipio.municipio) {
      console.log('Debug: Município ou dados não carregados');
      return true;
    }
    
    const municipioData = this.municipio.municipio;
    const temUsuarios = municipioData.quantidade_usuarios >= 2;
    const temServidores = municipioData.quantidade_servidores > 0;
    const temOrgaos = municipioData.quantidade_orgaos >= 2;
    const temPermissoes = this.hasPermissoesDefinidas();
    
    console.log('Debug - Verificação de pendências:');
    console.log('- Usuários:', municipioData.quantidade_usuarios, '>=2?', temUsuarios);
    console.log('- Servidores:', municipioData.quantidade_servidores, '>0?', temServidores);
    console.log('- Órgãos:', municipioData.quantidade_orgaos, '>=2?', temOrgaos);
    console.log('- Permissões definidas:', temPermissoes);
    
    const hasPendencias = !temUsuarios || !temServidores || !temOrgaos || !temPermissoes;
    console.log('- Resultado final (tem pendências):', hasPendencias);
    
    return hasPendencias;
  }

  // Método para verificar se uma permissão específica está ativa no município
  municipioHasPermissao(nomePermissao: string): boolean {
    if (!this.municipio || !this.municipio.modulos || !Array.isArray(this.municipio.modulos)) {
      return false;
    }
    
    return this.municipio.modulos.some(modulo => {
      if (!modulo.nome) return false;
      
      // Comparação mais flexível para nomes
      const nomeModulo = modulo.nome.toLowerCase().trim();
      const nomeBusca = nomePermissao.toLowerCase().trim();
      
      return nomeModulo.includes(nomeBusca) || nomeBusca.includes(nomeModulo);
    });
  }

  // Método para obter a cor do badge baseado na permissão
  getBadgeColor(badge: any): string {
    if (badge.tipo === 'pendencia') {
      return this.hasPendenciasCadastro() ? '#FAEBEB' : '#E8F5E8';
    }
    
    // Para permissões normais, verde se ativo, vermelho se inativo
    return this.municipioHasPermissao(badge.nome) ? '#aefcbf' : '#F2F2F2';
  }

  getBadgeTextColor(badge: any): string {
    if (badge.tipo === 'pendencia') {
      return this.hasPendenciasCadastro() ? '#C83030' : '#2D7D2D';
    }

    return this.municipioHasPermissao(badge.nome) ? '#108729' : '#707070 ';
  }
  // Método para obter o texto do badge
  getBadgeText(badge: any): string {
    // Para todos os badges, mostra apenas o nome em maiúsculas
    return badge.nome.toUpperCase();
  }

  // Verifica se há servidores cadastrados
  hasServidoresCadastrados(): boolean {
    return this.municipio && this.municipio.municipio && 
           this.municipio.municipio.quantidade_servidores > 0;
  }

  // Verifica se há permissões definidas para este município
  hasPermissoesDefinidas(): boolean {
    const temPermissoes = this.municipio && this.municipio.modulos && 
           this.municipio.modulos.length > 0;
    console.log('Debug - hasPermissoesDefinidas:');
    console.log('- municipio existe:', !!this.municipio);
    console.log('- modulos existe:', !!(this.municipio && this.municipio.modulos));
    console.log('- quantidade modulos:', this.municipio?.modulos?.length || 0);
    console.log('- resultado:', temPermissoes);
    return temPermissoes;
  }

  // Lista de pendências para exibir no alerta
  getPendenciasList(): string[] {
    const pendencias = [];
    
    if (!this.municipio || !this.municipio.municipio) return pendencias;
    
    const municipioData = this.municipio.municipio;
    
    if (municipioData.quantidade_orgaos < 2) {
      pendencias.push('É necessário ter pelo menos 2 órgãos cadastrados.');
    }
    
    if (municipioData.quantidade_servidores === 0) {
      pendencias.push('Não há servidores (usuários) cadastrados para operação do município no sistema.');
    }
    
    if (municipioData.quantidade_usuarios < 2) {
      pendencias.push('É necessário ter pelo menos 2 usuários cadastrados.');
    }
    
    if (!this.hasPermissoesDefinidas()) {
      pendencias.push('Não há permissões de acesso aos módulos do sistema definidas para este município.');
    }
    
    return pendencias;
  }

  // Voltar para a página anterior
  voltar() {
    this.router.navigate(['/page/admin']);
  }

  // Método para abrir a modal de edição
  openEditModal(content: any) {
    // Carrega os dados atuais do município nos campos de edição
    this.carregarDadosParaEdicao();
    
    const modal = this.modalService.open(content, { 
      centered: true, 
      size: "xl",
      backdrop: 'static',
      keyboard: false
    });
  }

  // Carrega os dados atuais para edição
  carregarDadosParaEdicao() {
    if (this.municipio && this.municipio.municipio) {
      // Aqui você pode carregar os dados reais do município
      // Por enquanto, vou usar dados de exemplo
      this.dadosEdicao = {
        cep: '91000-000',
        estado: 'RS',
        municipio: this.municipio.municipio.nome || '',
        logradouro: 'Rua Exemplo',
        numero: '123',
        complemento: '',
        bairro: 'Centro'
      };
      
      // Carrega municípios do estado selecionado
      this.carregarMunicipios();
    }
  }

  // Método chamado quando o estado muda
  onEstadoChange() {
    this.carregarMunicipios();
    this.dadosEdicao.municipio = ''; // Limpa o município selecionado
  }

  // Carrega municípios baseado no estado selecionado
  carregarMunicipios() {
    // Aqui você faria uma chamada para a API para buscar os municípios
    // Por enquanto, vou usar dados de exemplo
    if (this.dadosEdicao.estado === 'RS') {
      this.municipios = [
        { nome: 'Porto Alegre' },
        { nome: 'Canoas' },
        { nome: 'Pelotas' },
        { nome: 'Caxias do Sul' },
        { nome: 'Santa Maria' }
      ];
    } else if (this.dadosEdicao.estado === 'SP') {
      this.municipios = [
        { nome: 'São Paulo' },
        { nome: 'Campinas' },
        { nome: 'Santos' },
        { nome: 'São José dos Campos' }
      ];
    } else {
      this.municipios = [];
    }
  }

  // Salva os dados editados
  async salvarDados(modal: any) {
    try {
      console.log('Salvando dados:', this.dadosEdicao);
      
      // Aqui você faria a chamada para a API para salvar os dados
      // await this.cityService.updateCidade(this.idCidade, this.dadosEdicao);
      
      // Por enquanto, apenas simula o salvamento
      console.log('Dados salvos com sucesso!');
      
      modal.close('Save');
      
      // Recarrega os dados após salvar
      await this.loadData();
      
    } catch (error) {
      console.error('Erro ao salvar dados:', error);
    }
  }

  // Métodos para Integração FlaxFlow
  openModalDocumento(content, cidade){
    this.cidadeUsuarios.city = cidade;
    this.anexo = {
      arquivos: [],
      opcao: "processarEAnexar"
    };
    this.statusEnvio = '';
    const modal = this.modalService.open(content, { centered: true });
  }

  closeModal(modal) {
    this.anexo = {
      arquivos: [],
      opcao: "processarEAnexar"
    };
    this.statusEnvio = '';
    modal.close('Close click');
  }

  async selecionaArquivo(event: Event) {
    const input = event.target as HTMLInputElement;

    if (!input.files || input.files.length === 0) {
      return;
    }

    const arquivosSelecionados = Array.from(input.files);
    const arquivosValidos: File[] = [];

    for (const file of arquivosSelecionados) {
      arquivosValidos.push(file);
    }

    if (arquivosValidos.length > 0) {
      this.anexo.arquivos = arquivosValidos;
    } else {
      this.anexo.arquivos = [];
      input.value = ""; // limpa o input, já que nenhum arquivo é válido
    }
  }

  fileNameAndExt(str) {
    var file = str.split("/").pop();
    return [
      file.substr(0, file.lastIndexOf(".")),
      file.substr(file.lastIndexOf(".") + 1, file.length),
    ];
  }

  async postFile(extension, type) {
    const response = await this.apiCall
      .post(`servidor/arquivo/url`, { extension: extension, type: type })
      .pipe(take(1))
      .toPromise();
    if (response.result) {
      return response.result;
    } else {
      return null;
    }
  }

  mapAction(opcao){
    switch(opcao) {
      case "processar":
        return 1;
      case "anexar":
        return 2;
      default:
        return 0;
    }
  }

  async cadastrarAnexo(modal) {
    const self = this;

    if (!self.anexo.arquivos || self.anexo.arquivos.length === 0) {
      return;
    }

    await self.spinner.show(undefined, {
      type: "ball-triangle-path",
      size: "medium",
      bdColor: "rgba(0, 0, 0, 0.8)",
      color: "#fff",
      fullScreen: true,
    });

    const dadosUsuario = self.me.currentUserValue;
    const cidade = self.cidadeUsuarios.city;
    const nome = dadosUsuario?.user?.nome;

    try {
      for (let i = 0; i < self.anexo.arquivos.length; i++) {
        const file = self.anexo.arquivos[i];
        
        self.statusEnvio = `Enviando (${i + 1}/${self.anexo.arquivos.length}): ${file.name}`;

        // Verificar se o arquivo tem extensão
        if (file && self.fileNameAndExt(file.name)[1]) {
          try {
            const urlToPostFile = await self.postFile(
              self.fileNameAndExt(file.name)[1],
              file.type
            );

            if (!urlToPostFile) {
              console.error(`Falha ao obter URL para upload do arquivo: ${file.name}`);
              continue;
            }

            var optionsFile = {
              headers: { "Content-Type": file.type, "x-amz-acl": "public-read" },
            };

            const uploadFile = await self.api.http
              .put(urlToPostFile, file, optionsFile)
              .toPromise();

            const locationFile = urlToPostFile.toString().split("?", 1)[0];
            const idaction = this.mapAction(this.anexo.opcao);

            if (locationFile) {
              const result = await self.apiCall
                .post(`servidor/flaxflow/createFile?key=${locationFile}&idcidade=${this.cidadeUsuarios.city}&idaction=${idaction}&nameFile=${file.name}`)
                .pipe(take(1))
                .toPromise();
              
              console.log(`Arquivo ${file.name} enviado com sucesso:`, locationFile);

              // Enviar para FlaxFlow
              if (idaction === 2) {
                continue; // Pula o envio para FlaxFlow se a ação for apenas anexar
              }
              try {
                // Converter arquivo para base64 de forma compatível com browser
                const base64Content = await this.fileToBase64(file);
                const idfile = result.idfile;
                
                // Obter token da FlaxFlow
                const flaxflowToken = await self.apiCall
                  .get(`servidor/flaxflow/gettokenflaxflow`)
                  .pipe(take(1))
                  .toPromise();

                const uploadData = {
                  file: locationFile,
                  idfile: idfile,
                  token: flaxflowToken.token,
                  fileName: file.name,
                  fileSize: file.size
                };

                const resultSendFile = await self.apiCall
                  .post(`servidor/flaxflow/uploadfile`, uploadData)
                  .pipe(take(1))
                  .toPromise();

                var teste = resultSendFile.result;
                console.log(`Arquivo enviado para FlaxFlow: ${file.name}`, teste);

              } catch (flaxflowError) {
                console.error(`Erro ao enviar para FlaxFlow: ${file.name}`, flaxflowError);
              }
            }
          } catch (e) {
            console.error(`Erro ao enviar arquivo ${file.name}:`, e);
            await self.app.alert(
              `Erro`,
              `Falha ao enviar o arquivo "${file.name}".`,
              `error`
            );
          }
        }
      }

      await self.app.alert(`Sucesso`, `Todos os arquivos foram integrados com o FlaxFlow!`, `success`);
      modal.close("Close click");
      self.statusEnvio = '';
      await self.loadData();
    } catch (error) {
      console.error("Erro ao enviar arquivos", error);
      await self.app.alert(`Erro`, `Ocorreu um erro ao enviar os arquivos.`, `error`);
    } finally {
      await self.spinner.hide();
    }
  }

  private async fileToBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        resolve(reader.result as string);
      };
      reader.onerror = (error) => {
        reject(error);
      };
    });
  }

}
